import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { map, each } from 'lodash';
import { withRouter, Redirect, Switch, Route } from 'react-router-dom';
import { NavItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

import requiredSync from '../../../../components/required-sync';
import orgAwearness from '../../../../components/organization-awearness';
import { getUserCurrentOrganization } from '../../../Auth/AuthReducer';
import checkUserPermission from '../../../../components/check-user-permission';
import AmountPage from '../AmountPage/AmountPage';
import ProductPage from '../ProductPage/ProductPage';
import DealTypePage from '../DealTypePage/DealTypePage';
import IndustryPage from '../IndustryPage/IndustryPage';
import AccountSizePage from '../AccountSizePage/AccountSizePage';
import UserPage from '../UserPage/UserPage';
import OrganizationPage from '../OrganizationPage/OrganizationPage';
import FilterPage from '../FilterPage/FilterPage';
import SalesStagePage from '../SalesStagePage/SalesStagePage';
import CurrencySymbolPage from '../CurrencySymbolPage/CurrencySymbolPage';
import TruVoiceProductsPage from '../TruVoiceProductsPage/TruVoiceProductsPage';
import TruVoiceCollectorsPage from '../TruVoiceCollectorsPage/TruVoiceCollectorsPage';
import UserPermissionPage from '../UserPermissionPage/UserPermissionPage';
import CustomFieldPage from '../CustomFieldPage/CustomFieldPage';
import ForecastCategoryNamePage from '../ForecastCategoryNamePage/ForecastCategoryNamePage';
import CloseDatePage from '../CloseDatePage/CloseDatePage';
import LeaderboardPage from '../LeaderboardPage/LeaderboardPage';
import DiscoveryBotPage from '../DiscoveryBotPage/DiscoveryBotPage';
import DoNotContactPage from '../DoNotContactPage/DoNotContactPage';
import ConversionRatesPage from '../ConversionRates/ConversionRatesPage';
import NavDropDown from '../../components/NavDropDown/NavDropDown';
import TruVoiceTagsPage from '../TruVoiceTagsPage/TruVoiceTagsPage';
import TruVoiceStageHistoriesPage from '../TruVoiceStageHistoriesPage/TruVoiceStageHistoriesPage';
import FeedbackModulePage from '../FeedbackModulePage/FeedbackModulePage';
import TruVoiceFieldsPage from '../TruVoiceFieldsPage/TruVoiceFieldsPage';
import BenchmarkPage from '../BenchmarkPage/BenchmarkPage';
import FeedbackLanguagePage from '../FeedbackLanguagePage/FeedbackLanguagePage';
import ExclusionReasonsPage from '../ExclusionReasonPage/ExclusionReasonsPage';
import OwnerPagePage from '../OwnerPage/OwnerPage';
import EmailAlertsPage from '../EmailAlertsPage/EmailAlertsPage';
import UserTypePage from '../UserTypePage';

import QuickSearchFieldPage from '../QuickSearchPage/QuickSearchPage';


function SetupPage(props) {
  const { userCurrentOrganization, location: { pathname } } = props;


  const syncSettingPages = [
    {
      uri: '/setup/sync-settings',
      component: CustomFieldPage,
      label: 'Sync Settings',
    },
    {
      uri: '/setup/amount',
      component: AmountPage,
      label: 'Opportunity Amount',
    },
    {
      uri: '/setup/deal-types',
      component: DealTypePage,
      label: 'Opportunity Type',
    },
    {
      uri: '/setup/owner',
      component: OwnerPagePage,
      label: 'Owner',
    },
    ...(userCurrentOrganization.type !== 'hubspot' ? [
      {
        uri: '/setup/user-types',
        component: UserTypePage,
        label: 'Users',
      },
    ] : []),
    {
      uri: '/setup/products',
      component: ProductPage,
      label: 'Product',
    },
    {
      uri: '/setup/industries',
      component: IndustryPage,
      label: 'Industry',
    },
    {
      uri: '/setup/close-date',
      component: CloseDatePage,
      label: 'Close Date',
    },
    {
      uri: '/setup/forecast-categories',
      component: ForecastCategoryNamePage,
      label: 'Forecast Category',
    },
    {
      uri: '/setup/account-size',
      component: AccountSizePage,
      label: 'Account Size',
    },
  ];

  const uris = [
    ...map(syncSettingPages, 'uri'),
    '/setup/account-size/annual-revenue',
    '/setup/account-size/employee-count',
  ];


  let showNav = false;


  const subNavs = [];
  each(syncSettingPages, (comp) => {
    if (pathname.indexOf(comp.uri) === 0) {
      showNav = true;
    }
    subNavs.push((
      <LinkContainer key={comp.uri} to={comp.uri}>
        <NavItem>{comp.label}</NavItem>
      </LinkContainer>
    ));
  });

  return (
    <div>
      <Helmet title="Organization Setup" />
      <div className="container">
        <div className="clearfix">
          <div className="pull-right page-header-control">
            <NavDropDown location={props.location} />
          </div>
          <h1 className="page-header">
            Setup {userCurrentOrganization !== null && <span>for {userCurrentOrganization.display_name}</span>}
          </h1>
        </div>
      </div>

      {showNav &&
        <div className="container">
          <ul className="nav nav-tabs">
            {subNavs}
          </ul>
          <p />
        </div>
      }

      <Switch>
        {syncSettingPages.map((syncSettingPage) => {
          return (
            <Route key={syncSettingPage.uri} path={syncSettingPage.uri} component={syncSettingPage.component} />
          );
        })}

        <Route path="/setup/currency" component={CurrencySymbolPage} />
        <Route path="/setup/users" component={UserPage} />
        <Route path="/setup/organization" component={OrganizationPage} />
        <Route path="/setup/filters" component={FilterPage} />
        <Route path="/setup/sales-stages" component={SalesStagePage} />
        <Route path="/setup/truvoice-products" component={TruVoiceProductsPage} />
        <Route path="/setup/truvoice-collectors" component={TruVoiceCollectorsPage} />
        <Route path="/setup/truvoice-tags" component={TruVoiceTagsPage} />
        <Route path="/setup/truvoice-fields" component={TruVoiceFieldsPage} />
        <Route path="/setup/user-permissions" component={UserPermissionPage} />
        <Route path="/setup/leaderboard" component={LeaderboardPage} />
        <Route path="/setup/feedback-requests" component={DiscoveryBotPage} />
        <Route path="/setup/custom-do-not-contact-field" component={DoNotContactPage} />
        <Route path="/setup/conversion-rates" component={ConversionRatesPage} />
        <Route path="/setup/update-truvoice-data" component={TruVoiceStageHistoriesPage} />
        <Route path="/setup/feedback-module" component={FeedbackModulePage} />
        <Route path="/setup/benchmarks" component={BenchmarkPage} />
        <Route path="/setup/feedback-languages" component={FeedbackLanguagePage} />
        <Route path="/setup/exclusion-reasons" component={ExclusionReasonsPage} />
        <Route path="/setup/quick-search" component={QuickSearchFieldPage} />
        
        {false && <Route path="/setup/email-alerts" component={EmailAlertsPage} />}
        {(pathname === '/setup' && <Redirect to="/setup/filters" />)}
      </Switch>
    </div>
  );
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    userCurrentOrganization: getUserCurrentOrganization(state),
  };
}

SetupPage.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
  userCurrentOrganization: PropTypes.shape({
    _id: PropTypes.string,
    display_name: PropTypes.string,
  }).isRequired,
};

SetupPage.contextTypes = {
  router: PropTypes.object,
};

export default connect(mapStateToProps)(orgAwearness(checkUserPermission(requiredSync(withRouter(SetupPage)), ['admin'], '/')));
